<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mission.query.whCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in WhCodeList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                 <el-col :lg="5" :xl="5">
                    <el-form-item label="任务类型"  class="EL-Form-Item">
                        <el-select v-model="mission.query.taskType">
                            <el-option label="全部" value=""></el-option>
                            <el-option key="1" label="成品拉动" value="PRODUCT"></el-option>
                            <el-option key="2" label="物料拉动" value="MATERIAL"></el-option>
                            <el-option key="3" label="退料" value="BACKMAT"></el-option>
                            <el-option key="4" label="驳回" value="REJECT"></el-option>
                            <el-option key="5" label="点到点搬运" value="POINTPULL"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="任务状态" class="EL-Form-Item">
                        <el-select v-model="mission.query.taskStatus">
                            <el-option label="全部" value=""></el-option>
                            <el-option key="1" label="任务进行中" value="EXECUTE"></el-option>
                            <el-option key="2" label="任务取消" value="CANCEL"></el-option>
                            <el-option key="3" label="任务正常完成" value="COMPLETE"></el-option>
                            <el-option key="4" label="AGV异常" value="WARNCOMP"></el-option>
                            <el-option key="5" label="任务人工完成" value="PERSONCOMP"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <!-- <el-select v-model="mission.query.matCode" filterable :clearable="true" remote :remote-method="remoteMethod" @change="remoteMethod">
                            <el-option v-for="item in this.materialList" :key="item.mtId" :label="item.mtCode" :value="item.mtCode"></el-option>
                        </el-select> -->
                        <el-input v-model="mission.query.matCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getProdSparedyList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetClick('mission')">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装编号" class="EL-Form-Item">
                        <el-input v-model="mission.query.boxBarcode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col> 
               <el-col :lg="5" :xl="5">
                    <el-form-item label="任务编号" class="EL-Form-Item">
                        <el-input v-model="mission.query.taskCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="货位" class="EL-Form-Item">
                        <el-input v-model="mission.query.pathPoint" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mission.query.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mission.query.endTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="任务执行信息">
                <!-- @click="" -->
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M5_B1'" @click="personComplete()">人工确认完成</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M5_B2'" @click="insertShowRecordClick('mainSearchMat')">通道库存</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M5_B3'" @click="insertShowRecordClick('dot')">点对点配送</el-button>
                <el-button class="btn-t-delete" v-authority="'BACK_MENU3_M5_B4'" @click="deleteProdTaskDetail">删除任务</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M5_B5'"  @click="insertShowRecordClick('sysPointRouterData')">解绑和占用</el-button>
            </plabel>
            <h-table :headerCellStyle="mission.headerCellStyle" @pageChange="getProdSparedyList" style="flex: 1" :data="mission.data" pagination :nowPage.sync="mission.pageNum" :pageSize.sync="mission.pageSize" :total.sync="mission.total" @selectionChange="selectRepertory">
            <el-table-column type="selection" align="center"> </el-table-column>
            <el-table-column label="通道编号" prop="lineCode" align="center">
            </el-table-column>
            <el-table-column label="物料编号" prop="prodCode" align="center">
            </el-table-column>
            <el-table-column label="任务编号" prop="taskCode" align="center">
            </el-table-column>
            <el-table-column label="任务类型" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.taskType == 'PRODUCT'">成品拉动</span>
                    <span v-if="scope.row.taskType == 'MATERIAL'">物料拉动</span>
                    <span v-if="scope.row.taskType == 'BACKMAT'">退料</span>
                    <span v-if="scope.row.taskType == 'REJECT'">驳回</span>
                    <span v-if="scope.row.taskType == 'POINTPULL'">点到点搬运</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.taskStatus == 'EXECUTE'">任务进行中</span>
                    <span v-if="scope.row.taskStatus == 'CANCEL'">任务取消</span>
                    <span v-if="scope.row.taskStatus == 'COMPLETE'">任务正常完成</span>
                    <span v-if="scope.row.taskStatus == 'WARNCOMP'">AGV异常</span>
                    <span v-if="scope.row.taskStatus == 'PERSONCOMP'">任务人工完成</span>
                </template>
            </el-table-column>
            <el-table-column label="包装箱号" prop="boxBarcode" align="center">
            </el-table-column>
            <el-table-column label="当前步骤" prop="nowTcDesc" align="center">
            </el-table-column>
            <el-table-column label="任务路径" prop="taskPathPoint" align="center">
            </el-table-column>
            <el-table-column label="发送AGV" prop="agvFlag" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.agvFlag">Y</div>
                    <div v-if="!scope.row.agvFlag">N</div>
                </template>
            </el-table-column>
            <el-table-column label="agv小车" prop="agvCode" align="center">
            </el-table-column>
            <el-table-column label="备注" prop="remark" align="center">
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" align="center">
            </el-table-column>
            <el-table-column label="更新时间" prop="createTime" align="center">
            </el-table-column>
            <el-table-column label="操作" min-width="80" fixed="right">
                <template slot-scope="scope">
                    <div>
                        <el-button type="primary" class="btn-t-edit" plain @click="particularsClick(scope.row)">详情</el-button>
                    </div>
                </template>
            </el-table-column>
            </h-table>
        </box>
        <!-- 通道库存 -->
        <el-dialog title="通道库存" :visible.sync="mainSearchMat.insertShowRecord" class="fromDialog" :style="$popups.popups(0.82,0.9)" :close-on-click-modal="false">
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="当前通道" class="EL-Form-Item">
                        <el-select v-model="mainSearchMat.query.whCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in WhCodeList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.query.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.query.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="规值" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.matSpecs" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getStockPickList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete"  @click="resetClick('mainSearchMat')">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <h-table :headerCellStyle="mainSearchMat.headerCellStyle" class="fromDialog" :style="$popups.popups(0.8,0.73)" :close-on-click-modal="false" @pageChange="getStockPickList" :data="mainSearchMat.data" pagination :nowPage.sync="mainSearchMat.pageNum" :pageSize.sync="mainSearchMat.pageSize" :total.sync="mainSearchMat.total">
                <el-table-column label="通道编号" align="center" prop="whCode" />
                <el-table-column label="物料编号" align="center" prop="matCode" />
                <el-table-column label="物料描述" align="center" prop="matName" />
                <el-table-column label="数量" align="center" prop="matQuan" />
                <el-table-column label="批次号" align="center" prop="batchNo" />
                <el-table-column label="库位" align="center" prop="lcCode" />
                <el-table-column label="包装箱号" align="center" prop="boxBarcode" />
                <el-table-column label="规值" align="center" prop="matSpecs" />
                <el-table-column label="日期" align="center" prop="matCreateTime" />
                <el-table-column label="产品状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                        <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">作废</span>
                    </template>
                </el-table-column>
                <el-table-column label="地面位置" align="center" prop="routerCode" />
                <el-table-column label="记录状态" align="center" prop="recordStatus" />
                <el-table-column label="记录时间" align="center" prop="recordDate" />
            </h-table>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" type="info" @click="mainSearchMat.insertShowRecord = false">取 消</el-button>
                <!-- <el-button size="mini" class="btn-t-edit">确认</el-button> -->
            </span>
        </el-dialog>
        <!-- 点对点配送 -->
        <el-dialog title="点对点配送" :visible.sync="dot.insertShowRecord" class="fromDialog" :style="$popups.popups(0.5,0.3)" :close-on-click-modal="false">
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="8" :xl="8">
                    <el-form-item label="起点" class="EL-Form-Item">
                        <!-- <el-input v-model="dot.query.startPoint" placeholder="请输入" clearable></el-input> -->
                        <el-select v-model="dot.query.startPoint" filterable :clearable="true">
                            <el-option v-for="item in this.allDot" :key="item.point" :label="item.point" :value="item.point"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="终点" class="EL-Form-Item">
                        <el-select v-model="dot.query.endPoint" filterable :clearable="true">
                            <el-option v-for="item in this.allDot" :key="item.point" :label="item.point" :value="item.point"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="dot.query.boxBarcode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="备注" class="EL-Form-Item">
                        <el-input v-model="dot.query.remark" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" type="info" @click="dot.insertShowRecord = false">取 消</el-button>
                <el-button size="mini" class="btn-t-edit" @click="createPointToPointTask">确认</el-button>
            </span>
        </el-dialog>
        <!-- 解绑和占用 -->
        <el-dialog title="解绑和占用" :visible.sync="sysPointRouterData.insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false">
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="点位类型" class="EL-Form-Item">
                        <el-select v-model="sysPointRouterData.query.pointType" placeholder="请选择" @change="getPointChange()">
                            <el-option label="产线点" value="linePoint"></el-option>
                            <el-option label="备料点" value="MatSpare"></el-option> 
                            <el-option label="退料点" value="ReturnArea"></el-option> 
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item" v-if="sysPointRouterData.query.pointType == 'linePoint'">
                        <el-select v-model="sysPointRouterData.query.whCode" placeholder="请选择" clearable="clearable" @change="getSysLineRouterAllByWhCodePage">
                            <el-option v-for="item in WhCodeList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4" :offset="10" v-if="sysPointRouterData.query.pointType == 'linePoint'">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="updateChannelCodeOccupyFlag">
                            占用
                        </el-button>
                        <el-button class="btn-t-delete" @click="productUnboundContainer">
                            解绑
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4" :offset="15" v-if="sysPointRouterData.query.pointType != 'linePoint'">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="updateChannelCodeOccupyFlag">
                            占用
                        </el-button>
                        <el-button class="btn-t-delete" @click="productUnboundContainer">
                            解绑
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <h-table :headerCellStyle="sysPointRouterData.headerCellStyle" :style="$popups.harvestRecordStyle(0.68)" @pageChange="getPoint" :data="sysPointRouterData.data" pagination :nowPage.sync="sysPointRouterData.pageNum" :pageSize.sync="sysPointRouterData.pageSize" :total.sync="sysPointRouterData.total" @selectionChange="checkSysPointList">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="通道编号" prop="lineCode" align="center" v-if="sysPointRouterData.query.pointType == 'linePoint'"></el-table-column>
                <el-table-column label="点位类型" prop="lrType" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lrType == 'INPUT'">上料口</span>
                        <span v-if="scope.row.lrType == 'OUTPUT'">下料口</span>
                        <span v-if="scope.row.lrType == 'RETURN'">退料口</span>
                        <span v-if="scope.row.lrType == 'MatSpare'">备料区</span>
                        <span v-if="scope.row.lrType == 'ReturnArea'">退料区</span>
                    </template>
                </el-table-column>
                <el-table-column label="点位编号" prop="lrRealCode" align="center">
                </el-table-column>
                <el-table-column label="点位名称" prop="lrName" align="center">
                </el-table-column>
                <el-table-column label="是否占用" prop="occupyFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.occupyFlag == true">占用</span>
                        <span v-if="scope.row.occupyFlag == false">空闲</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="创建时间" prop="createTime" align="center">
                </el-table-column> -->
            </h-table>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" type="info" @click="closeInsertShowRecord">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="任务执行信息" :visible.sync="missionParticulars.insertShowRecord" class="fromDialog" :style="$popups.popups(0.82,0.9)" :close-on-click-modal="false">
            <h-table stripe :data="missionParticulars.detailData" :row-class-name="tableRowClassName" :style="$popups.popups(0.8,0.25)">
                <!-- <el-table-column prop="tmCode" label="执行编号"/>
                <el-table-column prop="tcName" label="执行描述"/> -->
                <el-table-column prop="tmCode" label="执行编号"/>
                <el-table-column prop="tcName" label="执行描述"/>
            </h-table>
            <h-table stripe :data="missionParticulars.agvResponse" :style="$popups.popups(0.8,0.25)">
                <el-table-column prop="arPoint" label="点位信息"/>
                <el-table-column prop="arMethod" label="AGV返回类型"/>
                <el-table-column prop="createTime" label="创建时间"/>
                <el-table-column prop="updateTime" label="修改时间"/>
            </h-table>
            <h-table stripe :data="missionParticulars.logData" :style="$popups.popups(0.8,0.25)">
                <el-table-column prop="ilRequest" label="接口请求日志" width="800px"/>
                <el-table-column prop="ilResponse" label="接口返回日志" width="300px"/>
                <el-table-column prop="createTime" label="创建时间"/>
                <el-table-column prop="updateTime" label="修改时间"/>
            </h-table>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" type="info" @click="missionParticulars.insertShowRecord = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MissionQuery",
    data(){
        return{
            /* 首页任务执行信息 */
            mission:{
                query:{
                    whCode: "", // 通道
                    matCode: "", // 物料编号
                    taskType:"", // 任务类型
                    taskStatus: "EXECUTE", // 任务状态
                    boxBarcode: "", // 箱号
                    missionMatCode: "", // 任务编号
                    pathPoint: "", // 库位
                    beginTime: new Date(new Date().getTime() - 2*24*60*60*1000), // 开始时间
                    endTime: new Date(new Date().getTime() + 24*60*60*1000), // 结束时间
                    taskCode: "", // 任务编号
                    fcCode: localStorage.getItem("fcCode"),
                },
                pageNum: 1,
                pageSize: 50,
                total: 0,
                data: [],
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            /* 点对点配送 */
            dot:{
                query:{
                    startPoint: "", // 起点
                    endPoint: "", // 终点
                    boxBarcode:"",
                },
                pageNum: 1,
                pageSize: 50,
                total: 0,
                data: [],
                insertShowRecord: false,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            /* 通道库存 */
            mainSearchMat: {
                query:{
                    whCode: "",
                    matCode: "",
                    boxBarcode: "",
                    matSpecs: "",
                },
                pageNum: 1,
                pageSize: 50,
                total: 0,
                data: [],
                insertShowRecord: false,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            /* 解绑和占用 */
            sysPointRouterData: {
                query:{
                    whCode: "",
                    pointType: "linePoint",
                },
                data: [],
                pageNum: 1,
                pageSize: 20,
                total: 0,
                insertShowRecord: false,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            missionParticulars:{
                detailData: [],
                Spaready: [],
                agvResponse: [],
                logData: [],
                insertShowRecord: false,
            },
            // 首页当前选中的数据
            checkList: [],
            // 库区集合
            WhCodeList: [],
            // 物料列表
            // materialList: [],
            /* 所有点位 */
            allDot: [],
            // 暂用解绑的多选
            checkSysPointRouter: [],
            // 输入框延时加载
            isSetTimeout: null,
            //点对点任务动态加载
            createPointToPointTaskLoading: false,
            //仓库点位类型
            spCode:"",
        }
    },
    computed:{  
        startPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.mission.query.endTime) {
                        return time.getTime() > new Date(_this.mission.query.endTime);
                    }
                }
            }
        },
        finishPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.mission.query.beginTime) {
                        return time.getTime() < new Date(_this.mission.query.beginTime);
                    }
                }
            }
        },
    },
    watch: {
        "mission.query": {
            handler() {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getProdSparedyList();
                }, 1000);
            },
            deep: true,
        },
        "mainSearchMat.query": {
            handler() {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getStockPickList();
                }, 1000);
            },
            deep: true,
        },
        // "sysPointRouterData.query": {
        //     handler() {
        //         clearTimeout(this.isSetTimeout)
        //         this.isSetTimeout = setTimeout(() => {
        //             this.getSysLineRouterAllByWhCode();
        //         }, 1000);
        //     },
        //     deep: true,
        // },
    },
    methods:{
        // 关闭
        closeInsertShowRecord(){
            this.sysPointRouterData.query.pointType = "产线点";
            this.sysPointRouterData.insertShowRecord = false;
        },
        // 所有弹出框的显示按钮
        insertShowRecordClick(type){
            if (type == "dot") {
                this.getSysLineAndPointRouterAll();
                this.dot.insertShowRecord = true;
            }else if (type == "mainSearchMat") {
                this.getStockPickList();
                this.mainSearchMat.insertShowRecord = true;
            }else if (type == "sysPointRouterData") {
                this.getSysLineRouterAllByWhCodePage();
                this.sysPointRouterData.insertShowRecord = true;
            }
        },
        /* 判断是否满足条件,满足条件返回对应的数据 */
        tableRowClassName({row}) {
            if (row.ifPossessClass) {
                return "success-row";
            }
        },
        /* 暂用解绑的多选 */
        checkSysPointList(val) {
            this.checkSysPointRouter = val;
        },
        /* 首页的多选 */
        selectRepertory(row){
            this.checkList = row;
        },
        /* 人工确认完成 */
        personComplete() {
            if (this.checkList.length != 1) {
                this.$message({
                    message: "请勾选一个AGV任务再进行人工确认完成操作！",
                    type: "warning",
                });
                return;
            } else{
                this.$confirm("是否人工确认完成该AGV任务?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {  
                    this.$http
                        .request({
                            url: "/agv/taskWhole/personComplete",
                            method: "POST",
                            params: {
                                taskCode: this.checkList[0].taskCode || "",
                                taskStatus: "PERSONCOMP",
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.getProdSparedyList();
                                this.$message({
                                    message: "人工确认完成！",
                                    type: "success",
                                });
                            }
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });      
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
            }
        },
        /* 获取成品区所有库位详情信息 */
        getSysLineRouterAllByWhCode() {
            this.$http
                .request({
                    url: "/api/sysLineRouter/getSysLineRouterAllByWhCode",
                    method: "GET",
                    params: {
                        fcCode: localStorage.getItem("fcCode") || "",
                        whCode: this.sysPointRouterData.query.whCode || null,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.sysPointRouterData.data = resp.data || [];
                    }
                })
                .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
        },
        /**
         * 获取备料区和退料区的点位
         */
        getSysPointRouterAll(){
            this.$http
                .request({
                    url: "/api/sysPointRouter/getSysPointRouterAll",
                    method: "GET",
                    params: {
                        pageNum: this.sysPointRouterData.pageNum || "",
                        pageSize:  this.sysPointRouterData.pageSize || null,
                        fcCode: localStorage.getItem("fcCode") || "",
                        spCode: this.spCode || null,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.sysPointRouterData.data = resp.data.list || [];
                        this.sysPointRouterData.total = resp.data.total;
                    }
                })
                .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
        },
        getPointChange(){
            this.sysPointRouterData.pageNum = 1;
            if(this.sysPointRouterData.query.pointType == "linePoint"){
                this.getSysLineRouterAllByWhCodePage();
            }else{
                this.spCode = this.sysPointRouterData.query.pointType;
                this.getSysPointRouterAll();
            }
        },
        getPoint(){
            if(this.sysPointRouterData.query.pointType == "linePoint"){
                this.getSysLineRouterAllByWhCodePage();
            }else{
                this.spCode = this.sysPointRouterData.query.pointType;
                this.getSysPointRouterAll();
            }
        },
        /**
         * 获取产线上所有的产线点
         */
        getSysLineRouterAllByWhCodePage() {
            this.$http
                .request({
                    url: "/api/sysLineRouter/getSysLineRouterAllByWhCodePage",
                    method: "GET",
                    params: {
                        pageNum: this.sysPointRouterData.pageNum || "",
                        pageSize:  this.sysPointRouterData.pageSize || null,
                        fcCode: localStorage.getItem("fcCode") || "",
                        whCode: this.sysPointRouterData.query.whCode || null,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.sysPointRouterData.data = resp.data.list || [];
                        this.sysPointRouterData.total = resp.data.total;
                    }
                })
                .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
        },
        /* 占用可用的产线点位 */
        updateChannelCodeOccupyFlag() {
            var every = this.checkSysPointRouter.every((item) => {
                return item.occupyFlag == true;
            })
            if (this.checkSysPointRouter.length < 1) {
                this.$message({
                    message: "请至少勾选一个产线点位！",
                    type: "warning",
                });
                return;
            } else if (every) {
                this.$message({
                    message: "选中的产线点位已未占用的无需解绑！",
                    type: "warning",
                });
                return;
            }
            this.$confirm("是否确认占用该产线点位?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.checkSysPointRouter.forEach((item) => {
                        this.$http
                            .request({
                                url: "/agv/pointrouter/occupyPoint",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    pointCode: item.lrRealCode,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    // this.getSysLineRouterAllByWhCodePage();
                                    this.getPointChange();
                                    this.$message({
                                        message: "占用成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                        })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        /* 解绑占用的产线点位 */
        productUnboundContainer() {
            var every = this.checkSysPointRouter.every((item) => {
                return item.occupyFlag == false;
            })
            if (this.checkSysPointRouter.length < 1) {
                this.$message({
                    message: "请勾选一个产线点位再进行解绑操作！",
                    type: "warning",
                });
                return;
            } else if (every) {
                this.$message({
                    message: "选中的产线点位未占用的无需解绑！",
                    type: "warning",
                });
                return;
            }
            this.$confirm("是否确认解绑该产线点位?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.checkSysPointRouter.forEach((item) => {
                        this.$http
                            .request({
                                url: "/agv/pointrouter/removeOccupy",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    pointCode: item.lrRealCode,
                                }
                            }).then((resp) => {
                                if (resp.status == 100) {
                                    // this.getSysLineRouterAllByWhCodePage();
                                    this.getPointChange();
                                    this.$message({
                                        message: "解绑成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                            }).catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        /* 点击解绑和占用按钮查询数据 */
        // untieOccupyClick() {
        //     this.untieOccupyDialog = true;
        //     this.$http
        //         .request({
        //             url: "/api/sysLineRouter/getSysLineRouterAllByWhCode",
        //             method: "GET",
        //             params: {
        //                 fcCode: localStorage.getItem("fcCode") || "",
        //             },
        //         })
        //         .then((resp) => {
        //             if (resp.status == 100) {
        //                 this.untieOccupyData.data = resp.data
        //             }
        //         })
        //         .catch((error) => {
        //             this.loading++;
        //         });
        // },
        /* 点对点配送 */
        createPointToPointTask(){
            this.$confirm("是否确认配送?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.createPointToPointTaskLoading = true;
                    this.$http
                        .request({
                            url: "/agv/taskWhole/createPointToPointTask",
                            method: "POST",
                            params: {
                                startPoint: this.dot.query.startPoint,
                                endPoint: this.dot.query.endPoint,
                                boxbarcodes: this.dot.query.boxBarcode || "",
                                personNumber: localStorage.getItem("empNumber"),
                                remark: this.dot.query.remark,
                            },
                        }).then((resp) => {
                            if (resp.status == 100) {
                                this.getProdSparedyList();
                                this.$message({
                                    message: "已确认配送！",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: resp.message,
                                    type: "warning",
                                });
                            }
                            this.createPointToPointTaskLoading = false;
                            this.dot.insertShowRecord = false;
                        }).catch((error) => {
                            this.createPointToPointTaskLoading = false;
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        /* 人工搬运完成 */
        updateProdTaskDetail(){
            if (this.checkList.length < 1) {
                this.$message({
                    message: "请勾选一个进行中的任务！",
                    type: "warning",
                });
                return;
            }else if (this.checkList.length > 1) {
                this.$message({
                    message: "只能对一个搬运任务进行完成任务！",
                    type: "warning",
                });
                return;
            } else if (!(this.checkList[0].taskStatus === 'START' || this.checkList[0].taskStatus === "EXECUTE")){
                this.$message({
                    message: "只能对开始和进行中的任务进行异常完成！",
                    type: "warning",
                });
                return;
            } else if (this.checkList[0].taskStatus == 'COMPLETE'){
                this.$message({
                    message: "完成状态的任务不能进行异常完成操作！",
                    type: "warning",
                });
                return;
            }
            this.$confirm("是否确认该任务为异常完成?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$http
                        .request({
                            url: "/agv/task/warnCompleteTask",
                            method: "POST",
                            params: {
                                taskCode: this.checkList[0].taskCode,
                            },
                        }).then((resp) => {
                            if (resp.status == 100) {
                                this.getProdSparedyList();
                                this.$message({
                                    message: "AGV异常完成成功！",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            }
                        }).catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        /* 删除任务 */
        deleteProdTaskDetail(){
            var every = this.checkList.every((item) => {
                return item.taskStatus == 'CANCEL';
            })
            if (this.checkList.length < 1) {
                this.$message({
                    message: "请勾选一个任务进行取消任务操作！",
                    type: "warning",
                });
                return;
            }else if (this.checkList.length > 1) {
                this.$message({
                    message: "只能对一个搬运任务进行取消任务！",
                    type: "warning",
                });
                return;
            } else if(this.checkList[0].taskStatus != 'START' && this.checkList[0].taskStatus != "EXECUTE"){
                this.$message({
                    message: "只能对开始和进行中状态的任务进行取消任务！",
                    type: "warning",
                });
                return;
            }else if (every) {
                this.$message({
                    message: "选中的任务已经取消无需再次取消！",
                    type: "warning",
                });
                return;
            }
            this.$confirm("是否确认取消该搬运任务?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$http
                        .request({
                            url: "/agv/task/cancelTask",
                            method: "PUT",
                            showLoading: true,
                            params: {
                                taskCode: this.checkList[0].taskCode || null,
                            },
                        }).then((resp) => {
                            if (resp.status == 100) {
                                this.getProdSparedyList();
                                this.$message({
                                    message: "取消搬运任务成功!",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: resp.message,
                                    type: "error",
                                });
                            }
                        });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        /* 点击展示详情 */
        particularsClick(taskCode){
            // nowTmCode
            this.missionParticulars.insertShowRecord = true;
            /* 第一个表格的请求 */
            this.$http
                .request({
                    url: "/api/taskCycle/getTaskCycle",
                    method: "GET",
                    params:{
                        tcCode: taskCode.tcCode,
                    }
                })
                .then((res) => {
                    if (res.status == 100) {
                        res.data.forEach(ele => {
                            if (ele.tmCode == taskCode.nowTmCode) {
                                ele.ifPossessClass = true;
                            }else{
                                ele.ifPossessClass = false;
                            }
                        });
                        if (res.data) {
                            this.missionParticulars.detailData = res.data;
                        }else{
                            this.missionParticulars.detailData = [];
                        };
                    } else {
                        this.$message.error("错误");
                    }
                });
            /* 第二个表格的请求 */
            this.$http
                .request({
                    url: "/api/agvResponse/agvResponseInfo",
                    method: "GET",
                    params:{
                        taskCode: taskCode.taskCode,
                    }
                })
                .then((res) => {
                    if (res.status == 100) {
                        if (res.data && res.data.list) {
                            this.missionParticulars.agvResponse = res.data.list;
                        }else{
                            this.missionParticulars.agvResponse = [];
                        };
                    } else {
                        this.$message.error("错误");
                    }
                });
            /* 第三个表格的请求 */
            this.$http
                .request({
                    url: "/api/interfaceLog/getInterfaceLog",
                    method: "GET",
                    params:{
                        taskCode: taskCode.taskCode,
                    }
                })
                .then((res) => {
                    if (res.status == 100) {
                        if (res.data && res.data.list) {
                            this.missionParticulars.logData = res.data.list;
                        }else{
                            this.missionParticulars.logData = [];
                        };
                    } else {
                        this.$message.error("错误");
                    }
                });
        },
        /* 所有重置的点击按钮 */
        resetClick(type){
            if (type == "mission") {
                this.mission.query = {
                    whCode: "", // 通道
                    matCode: "", // 物料编号
                    taskType:"", // 任务类型
                    taskStatus: "EXECUTE", // 任务状态
                    boxBarcode: "", // 箱号
                    missionMatCode: "", // 任务编号
                    pathPoint: "", // 库位
                    beginTime: new Date(new Date().getTime() - 2*24*60*60*1000), // 开始时间
                    endTime: new Date(), // 结束时间
                    taskCode: "", // 任务编号
                    fcCode: localStorage.getItem("fcCode"),
                };
            }else if(type == "mainSearchMat"){
                this.mainSearchMat.query = {
                    whCode: "",
                    matCode: "",
                    boxBarcode: "",
                    matSpecs: "",
                };
            }
        },
        /** 远程搜索起点点位 */
        remoteStartPoint(query){
            if (query !== "") {
                this.dot.startPoint = query;
                this.getSysLineAndPointRouterAll();
            } else {
                this.dot.startPoint = "";
                this.getSysLineAndPointRouterAll();
            }
            setTimeout(() => {
                if (this.allDot != undefined) {
                    this.allDot = this.allDot.filter((item) => {
                        return item.lrCode.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }
            }, 200);
        },
        /* 远程搜索点位 */
        remoteEndPoint(query){
            if (query !== "") {
                this.dot.endPoint = query;
                this.getSysLineAndPointRouterAll();
            } else {
                this.dot.endPoint = "";
                this.getSysLineAndPointRouterAll();
            }
            setTimeout(() => {
                if (this.allDot != undefined) {
                    this.allDot = this.allDot.filter((item) => {
                        return item.lrCode.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }
            }, 200);
        },
        /* 查询当前配送未使用的物料信息 */
        getStockPickList() {
            this.$http
                .request({
                    url: "/api/location/getSysLocationPage",
                    method: "GET",
                    params: {
                        matCode: this.mainSearchMat.query.matCode || null,
                        boxBarcode: this.mainSearchMat.query.boxBarcode || null,
                        matSpecs: this.mainSearchMat.query.matSpecs || null,
                        matLenValue: this.mainSearchMat.query.matLenValue || null,
                        whCode: this.mainSearchMat.query.whCode || null,
                        pageNum: this.mainSearchMat.pageNum,
                        pageSize: this.mainSearchMat.pageSize,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.mainSearchMat.data = resp.data.list || [];
                        this.mainSearchMat.total = resp.data.total;
                    }
                })
        },
        /* 远程搜索物料编号 */
        // remoteMethod(query) {
        //     if (query !== "") {
        //         this.mission.matCode = query;
        //         this.getMaterial();
        //     } else {
        //         this.mission.matCode = "";
        //         this.getMaterial();
        //     }
        //     setTimeout(() => {
        //         if (this.materialList != undefined) {
        //             this.materialList = this.materialList.filter((item) => {
        //                 return item.mtCode.toLowerCase().indexOf(query.toLowerCase()) > -1;
        //             });
        //         }
        //     }, 200);
        // },
        /* 物料列表 */
        // getMaterial() {
        //     this.$http
        //         .request({
        //             url: "/api/material/getMaterialAll",
        //             method: "GET",
        //             params: {
        //                 fcCode: localStorage.getItem("fcCode") || "",
        //                 mtCode: this.mission.matCode || null,
        //                 pageNum: 1,
        //                 pageSize: 1000,
        //             },
        //         })
        //         .then((res) => {
        //             if (res.status == 100) {
        //                 this.materialList = res.data.list;
        //             } else {
        //                 this.$message.error("错误");
        //             }
        //         });
        // },
        /* 获取所有的通道(根据用户工厂) */
        getSysWarehouseAll() {
            this.$http
                .request({
                    url: "/api/sysWarehouse/getSysWarehouseAll",
                    method: "GET",
                    params: {
                        fcCode: localStorage.getItem("fcCode") || "",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.WhCodeList = resp.data;
                    }
                })
                .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
        },
        /* 获取所有点位 */
        getSysLineAndPointRouterAll() {
            this.$http
                .request({
                    url: "/api/sysPointRouter/getSysLineAndPointRouterAll",
                    method: "GET",
                    params:{
                        fcCode: localStorage.getItem("fcCode")
                    }
                })
                .then((res) => {
                    if (res.status == 100) {
                        this.allDot = res.data.list;
                    }
                });
        },
        /* 获取首页的数据 */
        getProdSparedyList() {
            clearTimeout(this.isSetTimeout)
            this.$http
                .request({
                    url: "/api/prodTask/selectTaskList",
                    method: "GET",
                    params: {
                        fcCode: this.mission.query.fcCode || null,
                        lineCode: this.mission.query.whCode || null, // 通道
                        prodCode: this.mission.query.matCode || null, // 物料编号(产品料号)
                        taskType: this.mission.query.taskType || null, // 任务类型
                        taskStatus: this.mission.query.taskStatus || null, // 任务状态
                        boxBarcode: this.mission.query.boxBarcode || null, // 箱号
                        pathPoint: this.mission.query.pathPoint || null, // 点位
                        taskCode: this.mission.query.taskCode || null, // 任务编号
                        beginTime: this.mission.query.beginTime || null, // 开始时间
                        endTime: this.mission.query.endTime || null, // 结束时间
                        pageNum: this.mission.pageNum,
                        pageSize: this.mission.pageSize,
                    },
                })
                .then((res) => {
                    if (res.status == 100) {
                        this.mission.data = res.data.list || [];
                        this.mission.total = res.data.total;
                    } else {
                        this.$message.error("错误");
                    }
                })
                .catch((error) => {
                    this.$message.error("错误");
                });
        },
    },
    activated(){
        /* 物料编号列表 */
        // this.getMaterial();
        /* 通道列表 */
        this.getSysWarehouseAll();
        /* 获取所有点位 */
        this.getSysLineAndPointRouterAll()
        /* 获取首页的数据 */
        this.getProdSparedyList();
    },
}
</script>

<style>
    .el-table .success-row {
        color: #ff0000;
    }
</style>